import './questionary.css';
import { useState } from "react";

const ClientQuestionaryStepForm = () => {

    const link = localStorage.getItem("meetmindInviteLink") || "";

    const [formData, setFormData] = useState({
        secondName: '',
        firstName: '',
        middleName: '',
        birthday: '',
        email: '',
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch('https://meetmind.ru/v1/client/questionary/fill', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    "questionary": {
                        "email": formData.email,
                        "birthday": formData.birthday,
                        "first_name": formData.firstName,
                        "second_name": formData.secondName,
                        "middle_name": formData.middleName,
                        "link": link,
                    }
                }),
            });

            if (response.ok) {
                window.location.href = "/client/profile";
            } else {
                console.error('Ошибка при отправке данных');
            }
        } catch (error) {
            console.error('Произошла ошибка:', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="questionary">
                <h1 className="questionary__title">
                    Давайте пожаловать!
                </h1>
                <p className="questionary__paragraph">
                    Пожалуйста, заполните анкету.
                </p>
                <div className="questionary__icon">
                    <i className="fa-solid fa-chevron-down"></i>
                </div>
                <div className="questionary__block">
                    <h2 className="questionary__subtitle">
                        Контактная информация
                    </h2>
                    <div className="questionary__field">
                        <label className="questionary__label label">
                            Фамилия *
                            <input
                                className="questionary__input input"
                                type="text"
                                name="secondName"
                                value={formData.secondName}
                                onChange={handleInputChange}
                                placeholder="Иванов"
                            />
                        </label>
                    </div>
                    <div className="questionary__field">
                        <label className="questionary__label label">
                            Имя *
                            <input
                                className="questionary__input input"
                                type="text"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleInputChange}
                                placeholder="Иван"
                            />
                        </label>
                    </div>
                    <div className="questionary__field">
                        <label className="questionary__label label">
                            Отчество
                            <input
                                className="questionary__input input"
                                type="text"
                                name="middleName"
                                value={formData.middleName}
                                onChange={handleInputChange}
                                placeholder="Иванович"
                            />
                        </label>
                    </div>
                    <div className="questionary__field">
                        <label className="questionary__label label">
                            Дата рождения *
                            <input
                                className="questionary__input input"
                                type="date"
                                name="birthday"
                                value={formData.birthday}
                                onChange={handleInputChange}
                            />
                        </label>
                    </div>
                    <div className="questionary__field">
                        <label className="questionary__label label">
                            Адрес электронной почты
                            <input
                                className="questionary__input input"
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleInputChange}
                                placeholder="example@meetmind.ru"
                            />
                        </label>
                    </div>
                    <div className="questionary__actions">
                        <button type="submit" className="stepper__button button">Отправить анкету и завершить регистрацию</button>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default ClientQuestionaryStepForm;
